import Profileimg from '../images/profileimg.jpg';
import Nutritionallyyours from '../images/nutritionallyyours.PNG';
import Saafa from '../images/saafa.PNG';
import Facebookapp from '../images/facebook.PNG';
import Googleanalytics from '../images/googleanalytics.PNG';
import Moontravels from '../images/moontravels.PNG';
import Filmy4movies from '../images/filmy4movies.PNG';
import Tatallionhospitality from '../images/tatallion.PNG';
import Iphone from '../images/iphone.PNG';
import Slider from '../images/slider.PNG';
import Sorting from '../images/sort.PNG';
import Liquidsky from '../images/liquidsky.PNG';

import { ReactComponent as Html } from '../icons/html5.svg';
import { ReactComponent as Css } from '../icons/css3-alt.svg';
import { ReactComponent as PHP } from '../icons/php.svg';
import { ReactComponent as Python } from '../icons/python.svg';
import { ReactComponent as Javascript } from '../icons/square-js.svg';
import { ReactComponent as Wordpress } from '../icons/wordpress.svg';
import { ReactComponent as Reactjs } from '../icons/react.svg';



export const user = [
    {
        username : 'Jayesh B. Gawade',
        email : 'jayeshgawade8@gmail.com',
        IMG : Profileimg,
        linkdin : 'www.linkedin.com/in/jayesh-gawade-87bb47131',
        education : ['Diploma in Computer Engineering in 2016, NJBSPM New-Panvel', 
                    'B.E. Computer Engineering in 2020, CSMIT Panvel'],
        skills : ['HTML', 'CSS', 'JAVASCRIPT', 'WORDPRESS', 'REACTJS', 'PHP', 'PYTHON']
    }
]

export const datauser = [
    {
        wname: "Filmy4Movies",
        images : Filmy4movies,
        url:'filmy4movies.co.in',
        desc: "This is an website which i have created for movies blogs and also to reviews of the movies",
        lang: "HTML, CSS, JAVASCRIPT, PHP"
    },
    {
        wname: "NutritionallyYours",
        images : Nutritionallyyours,
        url:'nutritionallyyours.in',
        desc: "This is an website which i have created for Carlyne Remedios, I was create the website using wordpress and i used only free wordpress elements on the website",
        lang: "Wordpress, HTML, CSS, JAVASCRIPT, PHP"
    },
    {
        wname : "SAAFA BANQUETS",
        images : Saafa,
        url:'jayesh580.github.io/safa/',
        desc : "This is an website which i have created in june 2021 for SAAFA BANQUETS PUNE, I was create the website using html,css and javascript",
        lang : "HTML, CSS, JAVASCRIPT"
    },
    {
        wname: "Tatallion Hospitality",
        images : Tatallionhospitality,
        url:'jayesh580.github.io/tatallionhospitality/',
        desc: "This is an enthusiastic team of dedicated individuals with a passion for anything related to gastronomy and mixology.",
        lang: "HTML, CSS, JAVASCRIPT"
    },
    {
        wname : "Moon Travels",
        images : Moontravels,
        url:'moontravels1611.000webhostapp.com/index.php',
        desc : "I have design this traveling guid website from scratch in this website you can book tours packages and travel where you want to go",
        lang : "HTML, CSS, JAVASCRIPT, Core PHP"
    },
    {
        wname : "Liquid Sky",
        images : Liquidsky,
        url:'jayesh580.github.io/liquidsky1/',
        desc : "At LiquidSky Ventures Pvt Ltd, we aim to provide solutions for a cleaner environment. We advocate for the use of cutting-edge technologies to achieve environmental sustainability.",
        lang : "HTML, CSS, JAVASCRIPT"
    },
    {
        wname : "Google Analytics",
        images : Googleanalytics,
        url:'jayeshgwd580.github.io/googleanalytics/',
        desc : "This is an google analytics page replica which i created using reactjs and i have tried to make it as it is and also i am working on it",
        lang : "HTML, CSS, JAVASCRIPT, Reactjs"
    },
    {
        wname : "Facebook App",
        images : Facebookapp,
        url:'jayeshgwd580.github.io/facebook/',
        desc : "This is my assignment in the course where i have build a replica of the facebook app also for users i used api to fetch usernames",
        lang : "HTML, CSS, JAVASCRIPT, Reactjs"
    },
    {
        wname : "iPhone",
        images : Iphone,
        url:'jayesh580.github.io/iPhone/',
        desc : "This is my assignment in the course where i have build a replica of the iphone website",
        lang : "HTML, CSS, JAVASCRIPT, Bootstrap"
    },
    {
        wname : "Hero Slider",
        images : Slider,
        url:'jayesh580.github.io/slider/',
        desc : "I have created the Demo of Websites Hero Slider",
        lang : "HTML, CSS, JAVASCRIPT"
    },
    {
        wname : "Sorting Data",
        images : Sorting,
        url:'jayesh580.github.io/rect_proj/',
        desc : "I have created these react project which shows how sorting of data work in react js",
        lang : "HTML, CSS, JAVASCRIPT, Reactjs"
    },
]

export const skills = [
    {
        color : "one",
        title : "HTML5",
        cmpt : <Html fill='#fff' />,
        desc : `Strong knowledge of HTML syntax, elements, and attributes, including HTML5,
        Experienced in creating responsive we designs using HTML and CSS, ensuring compatibility with 
        different devices and screen sizes.`
    },
    {
        color : "two",
        title : "CSS",
        cmpt : <Css fill='#fff' />,
        desc : "Experienced in creating responsive web designs using HTML and CSS, ensuring compatibility with different devices and screen sizes."
    },
    {
        color : "three",
        title : "JavaScript",
        cmpt : <Javascript fill='#fff' />,
        desc : "Strong knowledge of JavaScript syntax, functions, objects, and arrays.Experienced in creating interactive and dynamic user interfaces using JavaScript, HTML, and CSS."
    },
    {
        color : "four",
        title : "Reactjs",
        cmpt : <Reactjs fill='#fff' />,
        desc : "Proficient in building complex user interfaces using React components, hooks, and Redux.Experienced in integrating React with APIs and handling data management using Redux."
    },
    {
        color : "five",
        title : "PHP",
        cmpt : <PHP fill='#fff' />,
        desc : "Proficient in developing dynamic and interactive web applications using Core PHP and various PHP frameworks such as Laravel, Skilled in implementing security measures, such as data validation and encryption, in Core PHP applications"
    },
    {
        color : "six",
        title : "Python",
        cmpt : <Python fill='#fff' />,
        desc : "Experienced in building web applications using frameworks such as Django and Flask.Familiar with object-oriented programming (OOP) principles and design patterns in Python."
    },
    {
        color : "seven",
        title : "Wordpress",
        cmpt : <Wordpress fill='#fff' />,
        desc : "Proficient in building custom WordPress themes and plugins using HTML, CSS, and PHP."
    },
]